"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("../actions/types");
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
var initialState = [];
var messagesReducer = function messagesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var _action$value = action.value,
    value = _action$value === void 0 ? {} : _action$value;
  var _value$messages = value.messages,
    messages = _value$messages === void 0 ? [] : _value$messages;
  switch (action.type) {
    case _types.RECEIVE_MESSAGES:
      return _organizeMessages(state, messages);
    case _types.HIDE_MESSAGES:
      {
        var idsToRemove = messages.map(function (msg) {
          return msg.id;
        });
        return state.filter(function (msg) {
          return !idsToRemove.includes(msg.id);
        });
      }
    default:
      return state;
  }
};
function _copyMessages(messages) {
  return messages.reduce(function (newMessages, currentMessage) {
    newMessages.push(Object.assign({}, currentMessage));
    return newMessages;
  }, []);
}
function _organizeMessages(state, messages) {
  if (state.length === 0) {
    return _toConsumableArray(messages);
  }
  var copy = _copyMessages(state);
  var groupedMessages = _groupMessagesById(copy);
  var incomingMessages = _removeAndUpdateDuplicatedMessages(messages, groupedMessages);
  var _splitMessages2 = _splitMessages(incomingMessages, copy[0].timestamp),
    _splitMessages3 = _slicedToArray(_splitMessages2, 2),
    oldMessages = _splitMessages3[0],
    newMessages = _splitMessages3[1];
  return [].concat(_toConsumableArray(oldMessages), _toConsumableArray(copy), _toConsumableArray(newMessages));
}
function _groupMessagesById(messages) {
  return messages.reduce(function (acc, message) {
    var id = message.id;
    acc[id] = message;
    return acc;
  }, {});
}
function _removeAndUpdateDuplicatedMessages(messages, groupedMessages) {
  return messages.filter(function (message) {
    var id = message.id,
      status = message.status,
      tip = message.tip,
      timestamp = message.timestamp,
      originalTimestamp = message.originalTimestamp;
    var oldMessage = groupedMessages[id];
    if (oldMessage) {
      oldMessage.status = status;
      oldMessage.timestamp = timestamp;
      oldMessage.originalTimestamp = originalTimestamp;
      if (tip !== null) {
        oldMessage.tip = tip;
      }
      return false;
    }
    return true;
  });
}
function _splitMessages(messages, pivot) {
  return messages.reduce(function (acc, message) {
    var _acc = _slicedToArray(acc, 2),
      oldMessages = _acc[0],
      newMessages = _acc[1];
    if (message.timestamp >= pivot) {
      newMessages.push(message);
    } else {
      oldMessages.push(message);
    }
    return [oldMessages, newMessages];
  }, [[], []]);
}
var _default = exports["default"] = messagesReducer;